import gameObjectTypes, { gameObjectTypesDefault } from './gameObjectTypes';
import gameSettings from './gameSettings';

export const regionNames = {
    REGION_1: 'region-1',
    REGION_2: 'region-2',
    REGION_3: 'region-3',
    REGION_4: 'region-4',
    REGION_5: 'region-5',
    REGION_6: 'region-6',
    REGION_7: 'region-7',
    REGION_8: 'region-8'
};

const distancePerRegion = (gameSettings.finalDistance / Object.keys(regionNames).length).toFixed(2);

export default [
    {
        name: regionNames.REGION_1,
        startAtDistance: 0,
        objects: [
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.BUSH_1_LEFT,
            gameObjectTypes.BUSH_1_RIGHT,
            gameObjectTypes.BUSH_2_LEFT,
            gameObjectTypes.BUSH_2_RIGHT,
            gameObjectTypes.SIGN_60_LEFT,
            gameObjectTypes.SIGN_60_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_1_SIGN
            },
            {
                type: gameObjectTypes.REGION_1_BUILDING
            }
        ]
    },
    {
        name: regionNames.REGION_2,
        startAtDistance: distancePerRegion * 1,
        objects: [
            gameObjectTypes.TREE_1_LEFT,
            gameObjectTypes.TREE_1_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_2_SIGN
            },
            {
                type: gameObjectTypes.REGION_LAKE
            }
        ]
    },
    {
        name: regionNames.REGION_3,
        startAtDistance: distancePerRegion * 2,
        objects: [
            gameObjectTypes.TREE_2_LEFT,
            gameObjectTypes.TREE_2_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_3_SIGN
            },
            {
                type: gameObjectTypes.REGION_3_BUILDING
            }
        ]
    },
    {
        name: regionNames.REGION_4,
        startAtDistance: distancePerRegion * 3,
        objects: [
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.TREE_2_LEFT,
            gameObjectTypes.TREE_2_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.SKIS_IN_SNOWDRIFT
            }
        ]
    },
    {
        name: regionNames.REGION_5,
        startAtDistance: distancePerRegion * 4,
        objects: [
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.ROCK_1_LEFT,
            gameObjectTypes.ROCK_1_RIGHT,
            gameObjectTypes.ROCK_2_LEFT,
            gameObjectTypes.ROCK_2_RIGHT,
            gameObjectTypes.SIGN_MOOSE_LEFT,
            gameObjectTypes.SIGN_MOOSE_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_5_SIGN
            },
            {
                type: gameObjectTypes.REGION_LAKE
            },
            {
                type: gameObjectTypes.ANIMAL_1_RIGHT
            },
            {
                type: gameObjectTypes.ANIMAL_2_RIGHT
            }
        ]
    },
    {
        name: regionNames.REGION_6,
        startAtDistance: distancePerRegion * 5,
        objects: [
            gameObjectTypes.TREE_3_LEFT,
            gameObjectTypes.TREE_3_RIGHT,
            gameObjectTypes.BUSH_3_LEFT,
            gameObjectTypes.BUSH_3_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.SLED_IN_SNOWDRIFT
            }
        ]
    },
    {
        name: regionNames.REGION_7,
        startAtDistance: distancePerRegion * 6,
        objects: [
            gameObjectTypes.SIGN_60_LEFT,
            gameObjectTypes.SIGN_60_RIGHT,
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.ROCK_3_LEFT,
            gameObjectTypes.ROCK_3_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_7_SIGN
            },
            {
                type: gameObjectTypes.REGION_7_BUILDING
            }
        ]
    },
    {
        name: regionNames.REGION_8,
        startAtDistance: distancePerRegion * 7,
        objects: [
            gameObjectTypes.TREE_4_LEFT,
            gameObjectTypes.TREE_4_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_8_SIGN
            },
            {
                type: gameObjectTypes.STUMP_RIGHT
            }
        ]
    }
];
